import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Modal from "../../common/Modal";
import { clearSelectedBrand, createBrandAsync, deleteBrandAsync, fetchBrandByIdAsync, selectBrandById, updateBrandAsync } from "../../brands/brandSlice";


function BrandForm() {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const alert = useAlert();

  const dispatch = useDispatch();
  const params = useParams();
  const selectedBrand = useSelector(selectBrandById);
  const [openModal, setOpenModal] = useState(null);

  useEffect(() => {
    if (params.id) {
      dispatch(fetchBrandByIdAsync(params.id));
    } else {
      dispatch(clearSelectedBrand());
    }
  }, [params.id, dispatch]);

  useEffect(() => {
    if (selectedBrand && params.id) {
      setValue("label", selectedBrand.label);
      setValue("value", selectedBrand.value);
    }
  }, [selectedBrand, params.id, setValue]);

  const handleDelete = () => {
    const brand = { ...selectedBrand };
    dispatch(deleteBrandAsync(brand.id));
    alert.success("Brand Deleted Successfully");
    reset();
  };

  return (
    <>
      <form
        noValidate
        onSubmit={handleSubmit((data) => {
          console.log(data);
          const brand = { ...data };
          console.log(brand);
          if (params.id) {
            brand.id = params.id;
            dispatch(updateBrandAsync(brand));
            alert.success("Brand Updated Successfully");
            reset();
          } else {
            dispatch(createBrandAsync(brand));
            alert.success("Brand Created Successfully");
            reset();
          }
        })}
      >
        <div className="space-y-12 bg-white p-12">
          <div className="border-b border-gray-900/10 pb-12">
            <h2 className="text-base font-semibold leading-7 text-gray-900">
              Add Brand
            </h2>

            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-6">
                <label
                  htmlFor="label"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Brand Label
                </label>
                <div className="mt-2">
                  <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 ">
                    <input
                      type="text"
                      {...register("label", {
                        required: "label is required",
                      })}
                      id="label"
                      className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                    />
                    {errors.label && (
                    <p className="text-red-500">{errors.label.message}</p>
                  )}
                  </div>
                </div>
              </div>

              <div className="col-span-full">
                <label
                  htmlFor="value"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Brand Value
                </label>
                <div className="mt-2">
                  <textarea
                    id="value"
                    {...register("value", {
                      required: "value is required",
                    })}
                    rows={3}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    defaultValue={""}
                  />
                  {errors.value && (
                    <p className="text-red-500">{errors.value.message}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-end gap-x-6">
          <Link to="/admin/brands">
            <button
              type="button"
              className="text-sm font-semibold leading-6 text-gray-900"
            >
              Cancel
            </button>
          </Link>
          {selectedBrand && (
            <button
              onClick={(e) => {
                e.preventDefault();
                setOpenModal(true);
              }}
              className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Delete
            </button>
          )}

          <button
            type="submit"
            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Save
          </button>
        </div>
      </form>
      {selectedBrand && (
        <Modal
          title={`Delete ${selectedBrand.label}`}
          message="Are you sure you want to delete this Brand ?"
          dangerOption="Delete"
          cancelOption="Cancel"
          dangerAction={handleDelete}
          cancelAction={() => setOpenModal(null)}
          showModal={openModal}
        ></Modal>
      )}
    </>
  );
}

export default BrandForm;
